import { FieldTypeConfig, FormlyFieldConfig } from '@ngx-formly/core';
import { FORMLY_FIELD_TYPES, FORMLY_FIELD_WRAPPERS } from '@app/constants';
import { isNil } from '@app/utils';
import { UnitSetupConfig } from './unit-setup-config.interface';

export const fiscalYearTabFields = (config: UnitSetupConfig): FormlyFieldConfig[] => {
	return [
		{
			wrappers: [FORMLY_FIELD_WRAPPERS.customWrapper],
			fieldGroup: [
				{
					type: FORMLY_FIELD_TYPES.headerLabel,
					props: {
						label: 'Fiscal Year Configuration',
						useElementH: '5',
						useSecondaryColor: true,
						horizontalLine: true,
						bold: true,
						useDefaultLineColor: true,
						marginBottom: 4,
					},
				},
				{
					fieldGroupClassName: 'row',
					fieldGroup: [
						{
							key: 'StartMonth',
							type: FORMLY_FIELD_TYPES.select,
							className: 'col-md-3',
							props: {
								label: 'Start Month',
								required: true,
							},
							expressions: {
								'props.options': 'formState.selects.monthsArray',
								'props.disabled': 'model?.StartMonth',
							},
						},
						{
							key: 'EndMonth',
							type: FORMLY_FIELD_TYPES.select,
							className: 'col-md-3',
							props: {
								label: 'End Month',
								required: true,
							},
							expressions: {
								'props.options': 'formState.selects.monthsArray',
								'props.disabled': 'model?.EndMonth',
							},
						},
					],
				},
			],
		},
		{
			wrappers: [FORMLY_FIELD_WRAPPERS.customWrapper],
			fieldGroup: [
				{
					type: FORMLY_FIELD_TYPES.headerLabel,
					props: {
						label: 'Closed Months',
						useElementH: '5',
						useSecondaryColor: true,
						horizontalLine: true,
						bold: true,
						useDefaultLineColor: true,
						marginBottom: 4,
					},
				},
				{
					fieldGroupClassName: 'row',
					fieldGroup: [
						{
							type: FORMLY_FIELD_TYPES.select,
							key: 'SelectedFiscalYearForClosedMonths',
							className: 'col-xs-12, col-sm-3',
							props: {
								label: 'Fiscal Year',
								change: (field: FieldTypeConfig) => {
									field.form.get('SelectedFiscalYearForClosedMonths')?.markAsPristine();
								},
							},
							expressions: {
								'props.options': 'formState.selects.createdFiscalYears',
								'props.label': 'model?.SelectedFiscalYearForClosedMonths ? `Fiscal Year` : `Select Fiscal Year`',
								'props.disabled': () => config.isReadOnly,
							},
						},
						{
							type: FORMLY_FIELD_TYPES.formlyMatButton,
							props: {
								matButtonName: 'mat-button',
								class: '',
								label: 'Create New Fiscal Year',
								icon: 'add',
								color: 'primary',
								onClick: () => config.createNewFiscalYear(),
							},
							expressions: {
								hide: () => config.isReadOnly,
							},
						},
						{
							fieldGroupClassName: 'row col-xs-12',
							fieldGroup: [
								{
									fieldGroupClassName: 'fy-month-container',
									fieldGroup: config.getFiscalYearMonthElements(),
									expressions: {
										hide: (field: FormlyFieldConfig) => {
											const hidden = isNil(field.model?.SelectedFiscalYearForClosedMonths);
											if (!hidden) {
												config.refreshClosedMonths(field.model?.SelectedFiscalYearForClosedMonths).then(() => {
													config.refreshTabFiscalYear(field);
												});
											}
											return hidden;
										},
									},
								},
							],
						},
					],
				},
			],
		},
	];
};
